/**
 * Fichier qui importe en mode module ( require commonJS )
 * et le renvoie en export default ==> pour pouvoir import en mode ES6 ( import )
 */

const Utils = require('./utils.js');
export default Utils 